import { useEffect, useState } from "react";
import Stack from "@mui/material/Stack";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import { Button, Checkbox, CircularProgress, Dialog, DialogTitle, Divider } from "@mui/material";
import {
	addOrEditModelAction,
	attrConditionalDisplayColObj,
	attrGrpTableStrColumnsObj,
	attributGrpColObj,
	attrTableStrColumnsObj,
	autoUpdateColData,
	autoUpdateGroupCol,
	constraintsAttrColObj,
	constraintsOptions,
	dependencyAttrColObj,
} from "components/PimDashboard/data";
import { GlobalState } from "context/GlobalContext";
import { grey } from "@mui/material/colors";
import { attrColStyle, dependencyAttrColStyle } from "../DesignerAttributeGroups";
import RenderInputField from "components/PimDashboard/CommonComponents/RenderInputField/RenderInputField";
import MultipleSelectInput from "components/PimDashboard/CommonComponents/MultipleSelectInput/MultipleSelectInput";
import { arrType, datatypes, inputTypes, selectOptionsKeyName } from "data/globalData";
import { attrGrpAttrAssocObj } from "../data";
import { PimDashboardState } from "context/PimDashboardContext";
import axios from "axios";
import { getColDefaultValue } from "components/PimDashboard/data";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";

const attrsFromAttrGrpObj = (attrGrpData, selectedAttr) => {
	if (attrGrpData && attrGrpData[attrGrpAttrAssocObj]?.length) {
		let arr = attrGrpData[attrGrpAttrAssocObj];
		return arr?.reduce(
			(acc, row) => {
				if (row?.key !== selectedAttr?.key) acc.list.push(row);
				return acc;
			},
			{ type: arrType, list: [] }
		);
	} else return { type: arrType, list: [] };
};

function AddOrEditModal({ action, attrGrpData, setAttrGrpData, setModalOpen, modalOpen, collection }) {
	const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();
	const { attrGroupsWithAttr, setAttrGroupsWithAttr, allAttributes } = PimDashboardState();

	const handleModalClose = () => {
		setModalOpen(false);
		setAttrGrpData();
	};
	const [attrConditionalDisplay, setAttrConditionalDisplay] = useState(false);
	const [attrTrigger, setAttrTrigger] = useState({ [attrConditionalDisplayColObj.key]: inputTypes.SELECT.key });
	const initialState = {
		[attrGrpTableStrColumnsObj.collection_type.key]: collection.key,
		[attrGrpTableStrColumnsObj.name.key]: "",

		[attrGrpTableStrColumnsObj.group_id.key]: "",
		[attrGrpTableStrColumnsObj.linked_table.key]: inputTypes.SELECT.key,
		[attrGrpTableStrColumnsObj.sort_no.key]: 0,
		data: {},
	};
	useEffect(() => {
		if (attrGrpData && action === addOrEditModelAction.UPDATE) setAttrInputData(attrGrpData);
		else setAttrInputData({ ...initialState });
	}, [modalOpen]);
	const [attrInputData, setAttrInputData] = useState({ ...initialState });
	console.log(attrInputData, "attrInputData");

	const handleSubmit = async (e) => {
		e.preventDefault();
		let obj = attrInputData;
		let unFilledArr = [];
		Object.keys(attrGrpTableStrColumnsObj).forEach((key) => {
			console.log(getColDefaultValue(attrGrpTableStrColumnsObj[key]), "sadsa");
			if (obj[key] === getColDefaultValue(attrGrpTableStrColumnsObj[key])) unFilledArr.push(attrGrpTableStrColumnsObj[key].name);
		});
		if (attrConditionalDisplay)
			if (obj.data?.[attrConditionalDisplayColObj.key] === getColDefaultValue(attrConditionalDisplayColObj))
				unFilledArr.push(attrConditionalDisplayColObj.name);

		if (unFilledArr.length) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Please fill the following fields: ${unFilledArr.join(", ")}`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			return;
		}

		if (attrConditionalDisplay) {
			obj = {
				...attrInputData,
				data: {
					...attrInputData.data,
					[attrConditionalDisplayColObj.key]: attrTrigger[attrConditionalDisplayColObj.key],
				},
			};
		}
		setLoadingOpen(true);
		try {
			if (action === addOrEditModelAction.UPDATE) {
				const res = await axios.post("/api/s/update_attr", attrInputData);
				setAttrGroupsWithAttr({
					...attrGroupsWithAttr,
					[attrGrpData?.group_id]: { ...attrGrpData, ...obj, res },
				});
			} else {
				const res = await axios.post("/api/attr_master/create_attr_grp", obj);
				setAttrGroupsWithAttr({
					...attrGroupsWithAttr,
					[res.data?.group_id]: { ...res.data, [attrGrpAttrAssocObj]: [] },
				});
			}
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: action === addOrEditModelAction.UPDATE ? "Attribute Group Updated" : "Attribute Group Created",
				severity: "success",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
			handleModalClose();
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
			setLoadingOpen(false);
		}
	};

	const handleDependencyAdd = (value) => {
		setAttrInputData({
			...attrInputData,
			[dependencyAttrColObj.key]: value?.reduce((acc, row) => {
				acc[row?.key] = true;
				return acc;
			}, {}),
		});
	};

	if (attrInputData && modalOpen)
		return (
			<Dialog onClose={handleModalClose} open={modalOpen} maxWidth="md" fullWidth>
				<Stack component="form" onSubmit={handleSubmit} p={1} spacing={1}>
					<Box>
						<Typography variant="h6" pt={0} width={"100%"} textTransform="capitalize">
							{action === addOrEditModelAction.UPDATE
								? `Update ${attrGrpData && attrGrpData[attrGrpTableStrColumnsObj.name.key]}`
								: "Add Attribute Group"}
						</Typography>

						{/* <Typography variant="h4" pt={0} width={"100%"}>
								
								</Typography> */}
						<Divider sx={{ width: "100%", mt: 1 }} />
					</Box>
					<Box display="flex" flexWrap="wrap" columnGap="3%" rowGap="15px" p={1}>
						{/* <Typography variant="body1" width="100%">
								Main Details
							</Typography> */}
						{Object.keys(attrGrpTableStrColumnsObj)?.map((key) => {
							return (
								<RenderInputField
									column={attrGrpTableStrColumnsObj[key]}
									data={attrInputData}
									setData={setAttrInputData}
									selectOptObjName={selectOptionsKeyName}
									dependencyColData={autoUpdateGroupCol}
								/>
							);
						})}
					</Box>
					<Stack spacing={1}>
						<Box display="flex" columnGap={1} alignItems="center">
							<Checkbox checked={attrConditionalDisplay} onChange={(e) => setAttrConditionalDisplay(e.target.checked)} />
							<Typography variant="body1" width="100%">
								Allow Attribute Conditional Display
							</Typography>
						</Box>
						{attrConditionalDisplay && (
							<RenderInputField
								width="40%"
								key={allAttributes}
								column={{
									...attrConditionalDisplayColObj,
									[selectOptionsKeyName]: { type: arrType, list: allAttributes?.length ? allAttributes : [] },
								}}
								data={attrTrigger}
								setData={setAttrTrigger}
								selectOptObjName={selectOptionsKeyName}
								// dependencyColData={}
							/>
						)}
					</Stack>
					<Box
						display="flex"
						flexWrap="wrap"
						pt={4}
						rowGap={3}
						className="vendorInputForm"
						columnGap={6}
						zIndex={-1}
						justifyContent="center"></Box>

					<Box alignSelf="flex-end" display="flex" columnGap={"10px"}>
						<Button variant="outlined" size="small" onClick={handleModalClose}>
							Cancel
						</Button>
						<Button variant="contained" type="submit" size="small">
							{action === "UPDATE" ? "UPDATE" : "CREATE"}
						</Button>
					</Box>
				</Stack>
			</Dialog>
		);
	else return <></>;
}

export default AddOrEditModal;
